import React, { useEffect, useState } from "react";
import { api, formatError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { toast } from "sonner";

export function TeachersAdminTab() {
  const [gurus, setGurus] = useState([]);
  const [payout, setPayout] = useState({});

  const load = () => api.get("/admin/gurus").then((r) => setGurus(r.data.items));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.put(`/admin/gurus/${id}/status`, { status }); toast.success(`${status}`); load(); }
    catch (e) { toast.error(formatError(e)); }
  };

  const pay = async (id) => {
    const amount = parseFloat(payout[id] || 0);
    if (!amount) return toast.error("Enter payout amount");
    try { await api.post(`/admin/gurus/${id}/payout`, { amount }); toast.success("Payout logged"); setPayout({ ...payout, [id]: "" }); load(); }
    catch (e) { toast.error(formatError(e)); }
  };

  const badge = (s) => s === "approved" ? "bg-green-100 text-green-800"
    : s === "pending" ? "bg-amber-100 text-amber-800"
    : s === "suspended" ? "bg-red-100 text-red-800" : "bg-gray-100 text-gray-800";

  return (
    <div data-testid="teachers-admin-tab" className="bg-[#FFFDF9] sacred-border rounded-2xl overflow-hidden">
      <div className="px-6 py-4 border-b border-[#D4AF37]/30">
        <div className="font-serif text-xl text-[#4A0E17]">Teachers · Gurus · Astrologers · Scholars</div>
        <div className="text-sm text-[#63534E] mt-1">{gurus.length} total · 80/20 revenue split per booking</div>
      </div>
      <table className="w-full text-sm">
        <thead className="bg-[#4A0E17] text-[#F3E5AB]"><tr>
          <th className="text-left px-4 py-3">Name</th>
          <th className="text-left px-4 py-3">Email</th>
          <th className="text-left px-4 py-3">Categories</th>
          <th className="text-left px-4 py-3">Status</th>
          <th className="text-right px-4 py-3">Earned / Paid</th>
          <th className="text-left px-4 py-3">Actions</th>
        </tr></thead>
        <tbody>
          {gurus.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-[#63534E]">No applications yet.</td></tr>}
          {gurus.map((g) => (
            <tr key={g.id} data-testid={`guru-row-${g.id}`} className="border-t border-[#D4AF37]/20">
              <td className="px-4 py-3"><div className="font-semibold">{g.name}</div><div className="text-xs text-[#63534E]">{g.title}</div></td>
              <td className="px-4 py-3 font-mono text-xs">{g.email}</td>
              <td className="px-4 py-3"><div className="flex flex-wrap gap-1">{(g.categories || []).map((c) => <span key={c} className="text-xs bg-[#F3E5AB]/50 px-2 rounded-full capitalize">{c}</span>)}</div></td>
              <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-xs ${badge(g.status)}`}>{g.status}</span></td>
              <td className="px-4 py-3 text-right font-mono text-xs">${(g.total_earned || 0).toFixed(2)} / ${(g.total_paid_out || 0).toFixed(2)}</td>
              <td className="px-4 py-3">
                <div className="flex flex-wrap items-center gap-2">
                  {g.status === "pending" && (
                    <>
                      <Button data-testid={`approve-${g.id}`} onClick={() => setStatus(g.id, "approved")} className="h-8 text-xs bg-[#2F7D32] hover:bg-[#1B5E20] rounded-full px-3">Approve</Button>
                      <Button data-testid={`reject-${g.id}`} onClick={() => setStatus(g.id, "rejected")} variant="outline" className="h-8 text-xs rounded-full px-3">Reject</Button>
                    </>
                  )}
                  {g.status === "approved" && (
                    <>
                      <Input data-testid={`payout-amt-${g.id}`} type="number" placeholder="Payout $" value={payout[g.id] || ""} onChange={(e) => setPayout({ ...payout, [g.id]: e.target.value })} className="w-24 h-8 text-xs" />
                      <Button data-testid={`payout-${g.id}`} onClick={() => pay(g.id)} className="h-8 text-xs bg-[#E65100] hover:bg-[#BF360C] rounded-full px-3">Pay</Button>
                      <Button data-testid={`suspend-${g.id}`} onClick={() => setStatus(g.id, "suspended")} variant="outline" className="h-8 text-xs rounded-full px-3">Suspend</Button>
                    </>
                  )}
                  {g.status === "suspended" && (
                    <Button data-testid={`reinstate-${g.id}`} onClick={() => setStatus(g.id, "approved")} className="h-8 text-xs bg-[#2F7D32] hover:bg-[#1B5E20] rounded-full px-3">Reinstate</Button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
